export default "__VITE_ASSET__e4f655a6__"